import { store } from 'DashboardBuilder/store'
import { Provider } from 'react-redux'
import Builder from 'DashboardBuilder/components/Builder'

export default function SurveyBuilder(params) {
  return (
    <Provider store={store}>
      <ErrorBoundary>
        <Builder {...params} />
      </ErrorBoundary>
    </Provider>
  )
}

